import { asyncConnect } from 'ha/modules/ReduxConnect';
import { loadHermesData } from 'ha/modules/Hermes';
import { getFavoriteListings } from 'ha/modules/FavoriteListing';
import collectionToFilters from 'ha/utils/filters/collectionToFilters';

import getSearchAlert from '../actions/getSearchAlert';
import {
  load,
  trackFilterApplied,
  getCollectionStats,
  loadAdvertiser,
  toggleMobileMap,
} from '../actions';
import {
  getPageName,
  getAnalyticsForListings,
  getAnalyticsForFilters,
  getSearchParams,
  getErrorState,
  getCityCanonical,
  getCountryCode,
  isNotFound,
} from '../selectors';
import { STATE_NAME } from '../constants';

import SearchRoot from '../components/SearchRoot';

const searchPromise = ({
  params,
  location: { pathname, query },
  store: { dispatch },
}) => {
  const localizedKind = params.localizedKind
    ? encodeURIComponent(params.localizedKind)
    : undefined;

  const { openMap, userId } = query;

  if (openMap) {
    dispatch(toggleMobileMap());
  }

  return dispatch(getCollectionStats(localizedKind, params.location)).then(
    stats =>
      Promise.all([
        dispatch(
          load({
            ...collectionToFilters(localizedKind, stats),
            ...params,
            ...query,
            localizedKind,
            priceAverage: stats.averagePrice,
          }),
        ),
        dispatch(loadHermesData(pathname)),
        dispatch(getFavoriteListings()),
        userId ? dispatch(loadAdvertiser(userId)) : Promise.resolve(),
      ]),
  );
};

const mapStateToProps = state => ({
  cityCanonical: getCityCanonical(state),
  countryCode: getCountryCode(state),
  error: getErrorState(state),
  pageName: getPageName(state),
  filtersAnalytics: getAnalyticsForFilters(state),
  searchParams: getSearchParams(state),
  listingsAnalytics: getAnalyticsForListings(state),
  notFound: isNotFound(state),
});

const mapDispatchToProps = {
  onTrackFilterApplied: trackFilterApplied,
  getSearchAlert,
};

const enhance = asyncConnect(
  [{ key: STATE_NAME, promise: searchPromise }],
  mapStateToProps,
  mapDispatchToProps,
);

export default enhance(SearchRoot);
